import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import ReactTableBase from 'src/shared/components/table/ReactTableBase';
import { useTranslation } from 'react-i18next';

const OrderReturnView = ({ reactTableData ,isNoRecordFound}) => {
  const [rows, setRows] = useState([]);
  const { t } = useTranslation('common');

  useEffect(() => {
    if (reactTableData && reactTableData.tableRowsData) {
      setRows(reactTableData.tableRowsData);
    } else {
      setRows([]);
    }
  }, [reactTableData]);

  const tableConfig = {
    isEditable: false,
    isSortable: true,
    isResizable: true,
    withPagination: true,
    withSearchEngine: true,
    manualPageSize: [10, 50, 100, 1000],
    placeholder: 'Search by Order No., Invoice No.,etc',
  };

  return (
    <div className="order-return-table-container">
      {isNoRecordFound && rows.length > 0 &&
        <ReactTableBase
          name={t('instution_type.view.name_map')}
          key={'searchable'}
          columns={reactTableData.tableHeaderData}
          data={rows}
          tableConfig={tableConfig}
        />
      }
    </div>
  );
};

OrderReturnView.propTypes = {
  reactTableData: PropTypes.shape({
    tableHeaderData: PropTypes.arrayOf(PropTypes.shape({
      key: PropTypes.string,
      name: PropTypes.string,
    })),
    tableRowsData: PropTypes.arrayOf(PropTypes.shape()),
  }).isRequired,
};

export default OrderReturnView;
